<template>
  <v-row
    no-gutters
    align-content="center">
    <v-col :cols="12">
      <div
        class="text-h6l px-0"
        style="color:black;">
        <slot/>
      </div>
    </v-col>
  </v-row>
</template>
<script>
/**
 * @file DDv2用アローヘッダ
 * @namespace components
 */

/**
 * @example
 * <dd-arrow-header>
 * example
 * </dd-arrow-header>
 */
export default {
  name: 'DdArrowHeader'
}
</script>
<style scoped>
.text-h6l {
  position: relative;
  padding-left: 25px;
  font-size: 1.5rem;
  font-weight: 700;
}
.text-h6l:before {
  position: absolute;
  content: '';
  bottom: -6px;
  left: 100%;
  width: 0;
  height: 0;
  border: none;
  border-right: solid 15px transparent;
  border-bottom: solid 15px rgb(47, 117, 181);
}
.text-h6l:after {
  position: absolute;
  content: '';
  bottom: -6px;
  left: 0;
  width: 100%;
  border-bottom: solid 3px rgb(47, 117, 181);
}
</style>
